goog.provide("shadow.js.shim.module$$carbon$icons_react$es$Chat$default");
shadow.js.shim.module$$carbon$icons_react$es$Chat$default = shadow.js.require(352, {}).default;
